class SearchStringBuilder {
  constructor() {
    this.azureString = "";
  }

  update(
    rawString,
    selectedCategoryId,
    selectedManufacturers,
    selectedSuppliers,
    isPromo
  ) {
    // Check rawString
    let rawStringIsEmpty = false;
    if (rawString === "") {
      rawStringIsEmpty = true;
    }

    // Check fuzzy For strings shorter than 3 chars search is not fuzzy. Strings in quote -> not fuzzy.
    let isFuzzy = true;

    if (rawString.length <= 1) {
      isFuzzy = false;
    }

    if (rawString.charAt(0) === '"') {
      // rawString = rawString.replace(/['"]+/g, "");
      isFuzzy = false;
    }

    if (isFuzzy && !rawStringIsEmpty) {
      this.azureString =
        "(ItemName:" + rawString + "~ OR Description:" + rawString + "~)";
    } else if (!isFuzzy && !rawStringIsEmpty) {
      this.azureString =
        "(ItemName:" + rawString + " OR Description:" + rawString + ")";
    } else if (rawStringIsEmpty) {
      this.azureString = "";
    }

    // Commercial type number
    if (selectedCategoryId !== null) {
      if (this.azureString !== "") {
        this.azureString += " AND";
      }
      this.azureString += " CommercialTypeNumber:" + selectedCategoryId;
    }

    // selected manufacturers
    if (selectedManufacturers !== null && selectedManufacturers !== undefined) {
      if (selectedManufacturers.length) {
        if (this.azureString !== "") {
          this.azureString += " AND";
        }

        this.azureString += " (";

        for (let i = 0; i < selectedManufacturers.length; i++) {
          this.azureString += "ManufacturerID: " + selectedManufacturers[i];
          if (i < selectedManufacturers.length - 1) {
            this.azureString += " OR ";
          }
        }

        this.azureString += ") ";
      }
    }

    // selected suppliers
    console.log("selectedSuppliers");
    console.log(selectedSuppliers);
    if (selectedSuppliers !== null && selectedSuppliers !== undefined) {
      if (selectedSuppliers.length) {
        if (this.azureString !== "") {
          this.azureString += " AND";
        }

        this.azureString += " (";

        for (let i = 0; i < selectedSuppliers.length; i++) {
          this.azureString += "ItemSuppliers: " + selectedSuppliers[i];
          if (i < selectedSuppliers.length - 1) {
            this.azureString += " OR ";
          }
        }

        this.azureString += ") ";
      }
    }

    if (isPromo) {
      // Promo
      this.azureString += "Promo:1";
    }
  }

  // addPromoFlag() {
  //   this.isPromo = true;
  // }

  // removePromoFlag() {
  //   this.isPromo = false;
  // }
}

export default SearchStringBuilder;
